import React from 'react';
import Emails from 'components/Emails';

const EmailsPage = () => {
  return <Emails />;
};

export default EmailsPage;
